"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKBottomActionBar = void 0;
var React = __importStar(require("react"));
var ReactDOM = __importStar(require("react-dom"));
var hooks_1 = require("../../../common/hooks");
var components_1 = require("../../../components");
var GKBABContainer_1 = require("./GKBABContainer/GKBABContainer");
/**
 * @deprecated in favor of GKActionBar.
 *
 * Bottom Action Bar component - Used to contain information and buttions when those actions pertain
 * to a large poriton (or multiple) portions of the screen and therefore do not make sense inline.
 * Can be used as a child of GKShell or a child of GKBABContainer.
 *
 */
var GKBottomActionBar = function (props) {
    // Intentionally destructured from otherProps
    var merged = (0, hooks_1.useMergedProps)(props, {
        _gkComponentIdentifier: "gk-bottom-action-bar",
    });
    var container = React.useContext(GKBABContainer_1.GKBABContainerContext).container;
    var ActionBar = React.createElement(components_1.GKActionBar, __assign({}, merged));
    return container ? ReactDOM.createPortal(ActionBar, container) : ActionBar;
};
exports.GKBottomActionBar = GKBottomActionBar;
